import PageBanner from "../components/ui/PageBanner";
import inpatientImg from "../assets/images/commitment/commitment-ward.jpeg";
import outpatientImg from "../assets/header-2.jpeg";
import "./Services.css";

export default function Services({ setPage }) {
  return (
    <>
      <PageBanner title="Our Services" crumbs={["Home", "Our Services"]} />

      <section className="section">
        <div className="section-inner">
          <div className="services__header">
            <p className="section-label">Clinical Services</p>
            <h3 className="section-title">Care That Fits Your Needs</h3>
            <p className="section-text">
              Explore our in-patient and out-patient services designed to provide safe, timely, and
              patient-centered care at Capital Care International Hospital.
            </p>
          </div>

          <div className="services__grid">
            <button
              type="button"
              className="services__card card"
              onClick={() => setPage("services-inpatient")}
            >
              <div className="services__img-wrap" aria-hidden="true">
                <img className="services__img" src={inpatientImg} alt="" loading="lazy" />
              </div>
              <div className="services__body">
                <h3 className="services__title">In-Patient Services</h3>
                <p className="services__text">
                  Surgical care, 24/7 emergency services, and critical care support including ICU
                  and NICU.
                </p>
                <span className="services__cta">View In-Patient Services</span>
              </div>
            </button>

            <button
              type="button"
              className="services__card card"
              onClick={() => setPage("services-outpatient")}
            >
              <div className="services__img-wrap" aria-hidden="true">
                <img className="services__img" src={outpatientImg} alt="" loading="lazy" />
              </div>
              <div className="services__body">
                <h3 className="services__title">Out-Patient Services</h3>
                <p className="services__text">
                  OPD consultations, preventive care, follow-ups, and diagnostics for day-to-day
                  health needs.
                </p>
                <span className="services__cta">View Out-Patient Services</span>
              </div>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
